import { Row } from "@circle-react-uikit/SkeletonLoader/components";

export const PlanSavingsSkeleton = () => (
  <div className="border-primary flex flex-col gap-y-2 border-t pt-2">
    <div className="flex justify-between">
      <Row md long />
      <Row md short />
    </div>
    <div className="flex justify-between">
      <Row md half />
      <Row md short />
    </div>
  </div>
);
